import { Drawer } from '@mui/material'

import theme from '../../theme'
import SidebarFooter from './SidebarFooter'
import SidebarNav from './SidebarNav'

export const MINI_DRAWER_WIDTH = 60

type Props = {
  isMediumDown: boolean
  mobileOpen: boolean
  desktopOpen: boolean
  onClose: () => void
  onOpen: () => void
  drawerWidth: number
}

const Sidebar = ({ isMediumDown, mobileOpen, desktopOpen, onClose, onOpen, drawerWidth }: Props) => {
  const currentWidth = isMediumDown ? drawerWidth : desktopOpen ? drawerWidth : MINI_DRAWER_WIDTH
  const isExpanded = isMediumDown ? true : desktopOpen

  return (
    <Drawer
      id="sidebar-drawer"
      variant={isMediumDown ? 'temporary' : 'permanent'}
      open={!isMediumDown || mobileOpen}
      onClose={onClose}
      sx={{
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: currentWidth,
          boxSizing: 'border-box',
          overflowX: 'hidden',
          top: theme.mixins.toolbar.minHeight,
          height: `calc(100% - ${theme.mixins.toolbar.minHeight}px)`,
          transition: `width ${theme.transitions.duration.leavingScreen}ms ${theme.transitions.easing.sharp}`,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
      slotProps={{ root: { keepMounted: true } }}
    >
      <SidebarNav
        isOpen={isExpanded}
        onClose={isMediumDown ? onClose : undefined}
        onOpen={onOpen}
        onToggle={isMediumDown ? undefined : desktopOpen ? onClose : onOpen}
      />
      {isExpanded && <SidebarFooter />}
    </Drawer>
  )
}

export default Sidebar
